































import { Component } from 'vue-property-decorator';
import { required } from 'vuelidate/lib/validators';
import { Validations } from 'vuelidate-property-decorators';
import AccountsService from '@/service/AccountsService';
import Base from '@/views/Base';
import { AxiosError } from 'axios';

@Component({})
export default class ForgotPasswordModal extends Base {
  model = {
    username: ''
  };

  @Validations()
  validation = {
    model: {
      username: { required }
    }
  };

  async submit(event: Event) {
    event.preventDefault();
    this.$v.model.$touch();
    if (this.$v.model.$invalid) {
      return;
    }

    try {
      await AccountsService.forgotPassword(this.model);
      this.toast(this.t('modals.forgotPassword.successMessage'), 'success');
      this.$bvModal.hide('forgot-password-modal');
    } catch (err) {
      const error = err as AxiosError;
      if(error.response?.status == 404) {
        this.toast(this.t('modals.forgotPassword.userNotFound'), 'danger');
        return;
      }
      else if(error.response?.status == 403) {
        this.toast(this.t('modals.forgotPassword.tokenExists'), 'danger');
        return;
      }

      this.showNetworkError(error);
    }
  }

  resetForm() {
    this.model.username = '';
    this.$v.$reset();
  }
}
